import { Response } from '@marketplace-web/core-api/api-client-util'

import {
  CountryBoundsDto,
  CountryBoundsModel,
  CountryBoundsResponse,
} from '../types/country-bounds'

export const transformCountryBoundsDto = ({
  radius,
  center,
  top_left,
  bottom_right,
  top_right,
  bottom_left,
}: CountryBoundsDto): CountryBoundsModel => ({
  radius,
  center,
  topLeft: top_left,
  bottomRight: bottom_right,
  topRight: top_right,
  bottomLeft: bottom_left,
})

export const transformCountryBounds = ({ country_bounds }: Response<CountryBoundsResponse>) => {
  if (!country_bounds) return null

  return transformCountryBoundsDto(country_bounds)
}

export const transformCountryBoundsResponse = (response: Response<CountryBoundsResponse>) =>
  transformCountryBounds(response)
